import React, { useState } from "react";
import styles from "../../assets/scss/Plans/Addplans.module.scss";
import { useCreatePlanMutation, useUpdatePlanMutation } from "../../slices/admin/admin";
import { toast } from "react-toastify";

const AddPlans = ({ onClose, editData }) => {

 const [formData, setFormData] = useState({
  planName: editData?.planName || "",
  durationTime: editData?.duration || "",   // ✅ FIXED HERE
  durationType: editData?.durationType || "",
  price: editData?.price || "",
  isFree: editData?.isFree || false,
  description: editData?.description || "",
});


  //console.log(editData,"editDataeditData555");
  

  const [createPlan] = useCreatePlanMutation();
  const [updatePlan] = useUpdatePlanMutation();


  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.planName.trim()) {
      newErrors.planName = "Plan Name is required";
    }

    if (!formData.durationTime) {
      newErrors.durationTime = "Duration Time is required";
    }

    if (!formData.durationType) {
      newErrors.durationType = "Duration Type is required";
    }

    if (!formData.isFree && !formData.price) {
      newErrors.price = "Price is required";
    }

    if (!formData.description.trim()) {   // ✅ VALIDATION ADDED
      newErrors.description = "Description is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  const payload = {
    planName: formData.planName,
    durationType: formData.durationType,
    duration: Number(formData.durationTime),
    price: formData.isFree ? 0 : Number(formData.price),
    isFree: formData.isFree,
    description: formData.description,
  };

  try {
    if (editData?._id) {
      const res = await updatePlan({
        id: editData._id,
        body: payload,
      }).unwrap();

      toast.success(res?.message || "Plan updated successfully ✅");
    } else {
      const res = await createPlan(payload).unwrap();

      toast.success(res?.message || "Plan created successfully ✅");
    }

    onClose();
  } catch (error) {
    toast.error(
      error?.data?.message || "Something went wrong ❌"
    );
  }
};



  return (
    <div className={styles.popupForm}>

      <div className={styles.header}>
        <h2 className={styles.tittle}>
          {editData ? "Edit Plan" : "Add Plan"}
        </h2>

        <span className={styles.closeIcons} onClick={onClose}>
          X
        </span>
      </div>

      <form onSubmit={handleSubmit}>

        <div className={styles.grid}>

          {/* Plan Name */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>
              Plan Name <span className={styles.required}>*</span>
            </label>
            <input
              type="text"
              name="planName"
              placeholder="Enter Plan Name"
              className={styles.input}
              value={formData.planName}
              onChange={handleChange}
            />
            {errors.planName && (
              <span className={styles.error}>{errors.planName}</span>
            )}
          </div>
          {/* Duration Type */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>
              Duration Type <span className={styles.required}>*</span>
            </label>
            <select
              name="durationType"
              className={styles.inputssss}
              value={formData.durationType}
              onChange={handleChange}
            >
              <option value="">Select Type</option>
              <option value="month">Month</option>
              <option value="year">Year</option>
            </select>

            {errors.durationType && (
              <span className={styles.error}>{errors.durationType}</span>
            )}
          </div>
          {/* Duration Time */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>
              Duration <span className={styles.required}>*</span>
            </label>
            <input
              type="number"
              name="durationTime"
              placeholder="Duration Time"
              className={styles.input}
              value={formData.durationTime}
              onChange={handleChange}
            />
            {errors.durationTime && (
              <span className={styles.error}>{errors.durationTime}</span>
            )}
          </div>



          {/* Price */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>
              Price <span className={styles.required}>*</span>
            </label>
            <input
              type="number"
              name="price"
              placeholder="Enter Price"
              className={styles.input}
              value={formData.price}
              onChange={handleChange}
              disabled={formData.isFree}
            />
            {errors.price && (
              <span className={styles.error}>{errors.price}</span>
            )}
          </div>

          {/* Description ✅ NEW FIELD */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>
              Description <span className={styles.required}>*</span>
            </label>
            <textarea
              name="description"
              placeholder="Enter Plan Description"
              className={styles.input}
              value={formData.description}
              onChange={handleChange}
              rows={3}
            />
            {errors.description && (
              <span className={styles.error}>{errors.description}</span>
            )}
          </div>

          {/* Checkbox */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>
              Is Free Plan? <span className={styles.required}>*</span>
            </label>
            <div>
              <input
                type="checkbox"
                name="isFree"
                checked={formData.isFree}
                onChange={handleChange}
              />
              &nbsp; Yes
            </div>
          </div>

        </div>

        <div className={styles.footerButtons}>
          <button
            type="button"
            className={styles.cancel}
            onClick={onClose}
          >
            Cancel
          </button>

          <button type="submit" className={styles.save}>
            {editData ? "Update Plan" : "Save Plan"}
          </button>
        </div>

      </form>
    </div>
  );
};

export default AddPlans;
